import { Button, Space, Tag, Popconfirm } from "antd";
import { EyeOutlined, EditOutlined, StopOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { docLinkRender } from "../../../components/table/DocLink";

export const FH_PENDING = "รอยืนยัน";
export const FH_CONFIRMED = "รับเข้าคลังแล้ว";
export const FH_CANCELLED = "ยกเลิก";
export const FH_STATUS = [FH_PENDING, FH_CONFIRMED, FH_CANCELLED];

export const StatusTag = ({ value }) => {
  const color =
    value === FH_CONFIRMED ? "green" : value === FH_CANCELLED ? "default" : "orange";
  return <Tag color={color}>{value || "-"}</Tag>;
};

export const num = (v) =>
  Number(v || 0).toLocaleString("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 3,
  });

export const fdate = (v) => (v ? dayjs(v).format("DD/MM/YYYY") : "");

export const accessColumn = ({ handleView, handleEdit, handleCancel }) => [
  {
    title: "เลขที่ใบส่งมอบ",
    dataIndex: "fhcode",
    key: "fhcode",
    width: 140,
    render: docLinkRender(handleView, "เปิดดูใบส่งมอบ"),
  },
  { title: "วันที่ส่งมอบ", dataIndex: "fhdate", key: "fhdate", width: 110, render: fdate },
  { title: "Production Order", dataIndex: "pdcode", key: "pdcode", width: 150 },
  { title: "สินค้า", dataIndex: "fg_names", key: "fg_names", ellipsis: true },
  {
    title: "สถานะ",
    dataIndex: "doc_status",
    key: "doc_status",
    width: 140,
    align: "center",
    render: (v) => <StatusTag value={v} />,
  },
  {
    title: "รับเข้าคลังเมื่อ",
    dataIndex: "confirmed_date",
    key: "confirmed_date",
    width: 150,
    render: (v) => (v ? dayjs(v).format("DD/MM/YYYY HH:mm") : ""),
  },
  { title: "สร้างโดย", dataIndex: "created_name", key: "created_name", width: 160 },
  {
    title: "Action",
    key: "action",
    fixed: "right",
    width: 130,
    render: (_, r) => (
      <Space>
        <Button size="small" icon={<EyeOutlined />} className="bn-success-outline" title="ดูข้อมูล" onClick={() => handleView(r)} />
        {r.doc_status === FH_PENDING && (
          <Button size="small" icon={<EditOutlined />} className="bn-primary-outline" title="แก้ไข / ยืนยันรับเข้าคลัง" onClick={() => handleEdit(r)} />
        )}
        {r.doc_status !== FH_CANCELLED && (
          <Popconfirm
            placement="topRight"
            title="ยกเลิกใบส่งมอบนี้?"
            description={r.doc_status === FH_CONFIRMED ? "ระบบจะถอน FG ออกจากคลัง (ถ้ายังไม่ถูกตัดออก)" : undefined}
            okText="ยกเลิกใบส่งมอบ"
            cancelText="ไม่"
            onConfirm={() => handleCancel(r)}
          >
            <Button size="small" danger icon={<StopOutlined />} title="ยกเลิก" />
          </Popconfirm>
        )}
      </Space>
    ),
  },
];
